export default `下記のURLにアクセスした後、電話番号とパスワードを入力してログインをお願いします。`;
